var _circle, _circle2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaintroller = function SvgPaintroller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.167,
    cy: 40.058,
    r: 39.222,
    fill: "#fff",
    stroke: "#A7A398"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.167,
    cy: 40.058,
    r: 39.222,
    fill: "#fff",
    stroke: "#A7A398"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.879 41.547.02-2.555a.466.466 0 0 0-.34-.45L23.4 34.081a.93.93 0 0 1-.695-.883l.05-6.62a.93.93 0 0 1 .937-.924l1.827.014-.008 1.08-1.695-.013-.048 6.322 17.58 4.576a.825.825 0 0 1 .617.804l-.024 3.117-1.062-.008Z",
    fill: "#002A1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.512 26.753-.025 3.363a.878.878 0 0 0 .872.884l30.256.229a.878.878 0 0 0 .885-.871l.057-7.543a.878.878 0 0 0-.872-.884l-30.256-.229a.878.878 0 0 0-.885.871l-.032 4.18Z",
    fill: "#BC5C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.88 41.544-1.097-.008a.616.616 0 0 0-.62.61l-.152 20.133a.606.606 0 0 0 .61.61l3.293.025a.615.615 0 0 0 .619-.601l.152-20.133a.623.623 0 0 0-.61-.62l-2.195-.016Z",
    fill: "#5C8283"
  })));
};
export default SvgPaintroller;